export default __webpack_public_path__ + "static/media/koala.7cc72448.png";